<template>
    <div id="edit-color-page">
        <div class="top-buttons">
            <ui5-button
                @click="saveColor"
                :disabled="loading || saving"
            >
                <spinner v-if="saving" />
                {{ trans('pages.edit_color.save') }}
            </ui5-button>
            <ui5-button @click="cancel">
                {{ trans('pages.edit_color.cancel') }}
            </ui5-button>
        </div>

        <pre
            class="debug"
            v-if="isDebug"
            >{{ { color, powderPicker } }}</pre
        >

        <spinner-text v-if="loading">
            {{ trans('pages.edit_color.loading') }}
        </spinner-text>
        <template v-else>
            <div>
                <div class="field">
                    <ui5-label
                        for="ralnr"
                        required
                    >
                        {{ trans('pages.edit_color.ral_number') }}
                    </ui5-label>
                    <ui5-input
                        type="Text"
                        name="ralnr"
                        id="ralnr"
                        @input="color.ralnr = $event.target.value"
                        :value="color.ralnr"
                    />
                </div>
                <div class="field">
                    <ui5-label
                        for="raltype"
                        required
                    >
                        {{ trans('pages.edit_color.ral_type') }}
                    </ui5-label>
                    <ui5-input
                        type="Text"
                        name="raltype"
                        id="raltype"
                        @input="color.raltype = $event.target.value"
                        :value="color.raltype"
                    />
                </div>
                <div class="field">
                    <ui5-label
                        for="poedernr"
                        required
                    >
                        {{ trans('pages.edit_color.powder_number') }}
                    </ui5-label>
                    <ui5-input
                        type="Text"
                        name="poedernr"
                        id="poedernr"
                        @input="color.poedernr = $event.target.value"
                        :value="color.poedernr"
                    />
                </div>
                <div class="field">
                    <ui5-label for="poedernr2">
                        {{ trans('pages.edit_color.powder_number_2') }}
                    </ui5-label>
                    <ui5-input
                        type="Text"
                        name="poedernr2"
                        id="poedernr2"
                        @input="color.poedernr2 = $event.target.value"
                        :value="color.poedernr2"
                    />
                </div>
                <div class="field">
                    <ui5-label for="poedernr3">
                        {{ trans('pages.edit_color.powder_number_3') }}
                    </ui5-label>
                    <ui5-input
                        type="Text"
                        name="poedernr3"
                        id="poedernr3"
                        @input="color.poedernr3 = $event.target.value"
                        :value="color.poedernr3"
                    />
                </div>
                <div class="field">
                    <ui5-label
                        for="colordescription"
                        required
                    >
                        {{ trans('pages.edit_color.description') }}
                    </ui5-label>
                    <ui5-input
                        type="Text"
                        name="colordescription"
                        id="colordescription"
                        @input="color.description = $event.target.value"
                        :value="color.description"
                    />
                </div>
                <div class="field">
                    <ui5-label
                        for="producent"
                        required
                    >
                        {{ trans('pages.edit_color.producer') }}
                    </ui5-label>
                    <ui5-input
                        type="Text"
                        name="producent"
                        id="producent"
                        @input="color.producent = $event.target.value"
                        :value="color.producent"
                    />
                </div>
                <div class="field">
                    <ui5-label for="tendon">
                        {{ trans('pages.edit_color.tendon') }}
                    </ui5-label>
                    <ui5-input
                        type="Text"
                        name="tendon"
                        id="tendon"
                        @input="color.tendon = $event.target.value"
                        :value="color.tendon"
                    />
                </div>
                <div class="field">
                    <ui5-label for="defaultColor">
                        {{ trans('pages.edit_color.default_color') }}
                    </ui5-label>
                    <ui5-switch
                        name="defaultColor"
                        id="defaultColor"
                        :text-on="trans('pages.edit_color.yes')"
                        :text-off="trans('pages.edit_color.no')"
                        :checked="color.defaultColor == '1'"
                        @change="
                            color.defaultColor = $event.target.checked
                                ? '1'
                                : '0'
                        "
                    ></ui5-switch>
                </div>
                <div class="field">
                    <ui5-label for="ralnr">
                        {{ trans('pages.edit_color.order') }}
                    </ui5-label>
                    <text-input
                        type="number"
                        name="order"
                        id="order"
                        v-model="color.orderColor"
                    />
                </div>
                <div class="field">
                    <ui5-label for="sort">
                        {{ trans('pages.edit_color.sorting') }}
                    </ui5-label>
                    <text-input
                        type="number"
                        name="sort"
                        id="sort"
                        v-model="color.sort"
                    />
                </div>
                <div class="field">
                    <ui5-label for="code">
                        {{ trans('pages.edit_color.powder') }}
                    </ui5-label>
                    <div
                        class="powder-code-display"
                        v-if="color.powderCode && color.powderCode.length"
                    >
                        <span>
                            {{ color.powderCode }}
                            {{ powderPicker.powderDescription }}
                        </span>
                        <i
                            @click="clearPowderFilter"
                            class="fa fa-close fa-1x"
                        />
                    </div>
                    <div v-else>
                        <ui5-input
                            type="Text"
                            name="code"
                            id="code"
                            :value="powderPicker.code"
                            @input="powderPicker.code = $event.target.value"
                            :placeholder="
                                trans('pages.edit_color.profile_number')
                            "
                            @change="searchPowders"
                            @keyup.enter="searchPowders"
                        />
                        <ui5-input
                            type="Text"
                            name="description"
                            id="description"
                            :value="powderPicker.description"
                            @input="
                                powderPicker.description = $event.target.value
                            "
                            :placeholder="trans('pages.edit_color.description')"
                            @change="searchPowders"
                            @keyup.enter="searchPowders"
                        />
                        <ui5-list :busy="powderPicker.busy">
                            <ui5-li
                                v-for="option in powderPicker.options"
                                :title="
                                    option.code + ' - ' + option.description
                                "
                                :key="'code.' + option.code"
                                @click="selectPowder(option)"
                            >
                                {{ option.code }} {{ option.description }}
                            </ui5-li>
                        </ui5-list>
                    </div>
                </div>
            </div>
            <div
                id="attached-suppliers-edit"
                v-if="idParam"
            >
                <h2>{{ trans('pages.edit_color.suppliers') }}</h2>
                <table class="striped-table">
                    <thead>
                        <tr>
                            <th rowspan="2">
                                {{ trans('pages.edit_color.supplier') }}
                            </th>
                            <th rowspan="2">
                                {{ trans('pages.edit_color.show') }}
                            </th>
                            <th colspan="2">
                                {{ priceFieldLabel(1) }}
                            </th>
                            <th colspan="2">
                                {{ priceFieldLabel(2) }}
                            </th>
                            <th colspan="2">
                                {{ priceFieldLabel(3) }}
                            </th>
                        </tr>
                        <tr>
                            <template v-for="n in priceFields">
                                <th :key="'h-default-' + n">{{ trans('pages.edit_color.is_default') }}</th>
                                <th :key="'h-price-' + n">{{ trans('pages.edit_color.price_category') }}</th>
                            </template>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="supplier in color.attachedSuppliers"
                            :key="'attached-supplier-' + supplier.id"
                        >
                            <td>
                                <div>
                                    <b>{{ supplier.name }}</b>
                                </div>
                                <br />
                                <div>
                                    {{ trans('pages.edit_color.supplier_of') }}
                                </div>
                                <ul>
                                    <li
                                        v-for="productType in supplier.productTypes"
                                    >
                                        {{ productType.externalName }}
                                    </li>
                                </ul>
                            </td>
                            <td>
                                <ui5-switch
                                    :text-on="trans('pages.edit_color.yes')"
                                    :text-off="trans('pages.edit_color.no')"
                                    :checked="!!supplier.isActive"
                                    @change="supplier.isActive = $event.target.checked"
                                />
                            </td>
                            <template v-for="n in priceFields">
                                <td :key="'standard-' + n">
                                    <ui5-switch
                                        :text-on="trans('pages.edit_color.yes')"
                                        :text-off="trans('pages.edit_color.no')"
                                        :checked="!!supplier['isStandardPricefield' + n]"
                                        @change="supplier['isStandardPricefield' + n] = $event.target.checked"
                                    />
                                </td>
                                <td :key="'price-' + n">
                                    <text-input
                                        type="number"
                                        v-model="supplier['priceCategoryIdPricefield' + n]"
                                        :placeholder="trans('pages.edit_color.price_category')"
                                        min="0"
                                    />
                                </td>
                            </template>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>
    </div>
</template>
<script>
import genericApi from '../api/generic';
import colorApi from '../api/color';
import priceListLabelsApi from '../api/priceListLabels';
import SpinnerText from '../components/loader/SpinnerText';
import Spinner from '../components/loader/Spinner';
import IsDebugMixin from '../mixins/is-debug';
import IdParamMixin from '../mixins/id-param';
import { showErrorMessage } from '../dialogs';
import TextInput from '../components/TextInput.vue';

export default {
    components: { Spinner, SpinnerText, TextInput },
    data() {
        return {
            priceFields: [1, 2, 3],
            priceListLabels: [],
            loading: false,
            saving: false,
            powderPicker: {
                busy: false,
                code: '',
                description: '',
                options: [],
                powderDescription: '',
            },
            color: {
                ralnr: '',
                raltype: '',
                poedernr: '',
                poedernr2: '',
                poedernr3: '',
                description: '',
                producent: '',
                tendon: '',
                defaultColor: '0',
                orderColor: '',
                powderCode: '',
                sort: 0,
                attachedSuppliers: [],
            },
        };
    },
    mixins: [IsDebugMixin, IdParamMixin()],
    methods: {
        load() {
            if (this.idParam) {
                this.populateEditColorPage();
            }
        },
        priceFieldLabel(n) {
            const entry = this.priceListLabels.find(
                (label) => label.priceListIndex === n - 1
            );

            return (entry && entry.label) || this.trans('pages.color_page.price_field_label', { n });
        },
        validate() {
            // Required fields
            if (
                this.color.ralnr == '' ||
                this.color.raltype == '' ||
                this.color.poedernr == '' ||
                this.color.producent == '' ||
                this.color.description == ''
            ) {
                showErrorMessage(
                    this.trans('pages.edit_color.errors.required_fields')
                );
                return false;
            }

            // RAL number can only be 10 characters long
            if (this.color.ralnr.length > 10) {
                showErrorMessage(
                    this.trans('pages.edit_color.errors.ral_number_too_long', {
                        max: 10,
                    })
                );
                return false;
            }

            // RAL type can only be 5 characters long
            if (this.color.raltype.length > 5) {
                showErrorMessage(
                    this.trans('pages.edit_color.errors.ral_type_too_long', {
                        max: 5,
                    })
                );
                return false;
            }

            // Powder number can only be 30 characters long
            if (this.color.poedernr.length > 30) {
                showErrorMessage(
                    this.trans(
                        'pages.edit_color.errors.powder_number_too_long',
                        {
                            max: 30,
                        }
                    )
                );
                return false;
            }

            // Optional Powder number 2 can only be 30 characters long
            if (
                this.color.poedernr2 != null &&
                this.color.poedernr2.length > 30
            ) {
                showErrorMessage(
                    this.trans(
                        'pages.edit_color.errors.powder_number_2_too_long',
                        {
                            max: 30,
                        }
                    )
                );
                return false;
            }

            // Optional Powder number 3 can only be 30 characters long
            if (
                this.color.poedernr3 != null &&
                this.color.poedernr3.length > 30
            ) {
                showErrorMessage(
                    this.trans(
                        'pages.edit_color.errors.powder_number_3_too_long',
                        {
                            max: 30,
                        }
                    )
                );
                return false;
            }

            // Optional Producent can only be 30 characters long
            if (
                this.color.producent != null &&
                this.color.producent.length > 30
            ) {
                showErrorMessage(
                    this.trans('pages.edit_color.errors.producent_too_long', {
                        max: 30,
                    })
                );
                return false;
            }

            // Optional Tendon can only be 50 characters long
            if (this.color.tendon != null && this.color.tendon.length > 50) {
                showErrorMessage(
                    this.trans('pages.edit_color.errors.tendon_too_long', {
                        max: 50,
                    })
                );
                return false;
            }

            return true;
        },
        selectPowder(powder) {
            this.color.powderCode = powder.code;
            this.powderPicker.powderDescription = powder.description;
        },
        clearPowderFilter() {
            this.color.powderCode = '';
            this.powderPicker.powderDescription = '';
        },
        searchPowders() {
            this.powderPicker.busy = true;
            genericApi
                .listGeneric(
                    'activeprofiles',
                    'code',
                    'code',
                    'description',
                    this.powderPicker.code,
                    this.powderPicker.description,
                    null
                )
                .then((response) => {
                    this.powderPicker.options = response.data.data;
                })
                .finally(() => {
                    this.powderPicker.busy = false;
                });
        },
        cancel() {
            if (this.idParam) {
                this.$router.push('/colorpage/' + this.idParam);
            } else {
                this.$router.push('/coloroverview');
            }
        },
        populateEditColorPage() {
            const colorId = this.idParam;
            this.loading = true;
            Promise.all([
                colorApi.fetch(colorId).then((response) => {
                    const color = response.data.data;

                    this.$store.commit(
                        'general/setPageTitle',
                        'Kleur ' +
                            color.ralnr +
                            color.raltype +
                            ' ' +
                            color.poedernr,
                        { root: true }
                    );

                    this.color.ralnr = color.ralnr;
                    this.color.raltype = color.raltype;
                    this.color.poedernr = color.poedernr;
                    this.color.poedernr2 = color.poedernr2;
                    this.color.poedernr3 = color.poedernr3;
                    this.color.description = color.description;
                    this.color.producent = color.producent;
                    this.color.tendon = color.tendon;
                    this.color.defaultColor = color.defaultColor;
                    this.color.orderColor = color.order;
                    this.color.powderCode = color.powderCode;
                    this.color.sort = color.sort;
                    this.powderPicker.powderDescription =
                        color.powderDescription;
                }),
                colorApi.fetchAttachedSuppliers(colorId).then((response) => {
                    this.color.attachedSuppliers = response.data.data;
                }),
                priceListLabelsApi
                    .fetch()
                    .then((response) => {
                        this.priceListLabels = response.data.data;
                    })
                    .catch(() => {
                        this.priceListLabels = [];
                    }),
            ]).then(() => {
                this.loading = false;
            });
        },
        saveColor() {
            this.saving = true;

            if (!this.validate()) {
                this.saving = false;
                return;
            }

            var payload = {};

            if (this.idParam != null) {
                payload.colorId = this.idParam;
            }

            payload.ralnr = this.color.ralnr;
            payload.raltype = this.color.raltype;
            payload.poedernr = this.color.poedernr;
            payload.description = this.color.description;

            if (this.color.poedernr2 != '') {
                payload.poedernr2 = this.color.poedernr2;
            }

            if (this.color.poedernr3 != '') {
                payload.poedernr3 = this.color.poedernr3;
            }

            if (this.color.producent != '') {
                payload.producent = this.color.producent;
            }

            if (this.color.tendon != '') {
                payload.tendon = this.color.tendon;
            }

            if (this.color.defaultColor == '1') {
                payload.defaultColor = true;
            }

            if (this.color.orderColor != '') {
                payload.orderColor = this.color.orderColor;
            }

            if (this.color.powderCode != '') {
                payload.powderCode = this.color.powderCode;
            }

            if (this.color.sort != '') {
                payload.sort = this.color.sort;
            }

            colorApi
                .update(payload)
                .then((response) => {
                    const colorId = response.data.data.colorId;

                    if (this.color.attachedSuppliers.length == 0) {
                        return { supplierResponse: null, colorId };
                    }

                    return colorApi
                        .updateOrAttachSuppliers(
                            colorId,
                            this.color.attachedSuppliers
                        )
                        .then((supplierResponse) => ({
                            supplierResponse,
                            colorId,
                        }));
                })
                .then(({ supplierResponse, colorId }) => {
                    if (colorId != null) {
                        this.$router.push('/colorpage/' + colorId);
                    } else {
                        this.$router.push('/coloroverview');
                    }
                })
                .catch(() => {
                    return showErrorMessage(
                        this.trans('pages.edit_color.errors.save_failed')
                    );
                })
                .finally(() => {
                    this.saving = false;
                });
        },
    },
};
</script>
